'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { BaseLineSearch } from '@/app/components/icons/BaseLineSearch';
import { cn } from '@/app/utils';
import { hysdk } from '@/app/utils/client';
import { SearchDialog } from './SearchDialog';

export const Search = () => {
  const t = useTranslations();
  const label = t('claw.nav.searchSession');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const modifierKey = hysdk.sniff.isMacOS ? '⌘' : 'Ctrl ';

  return (
    <>
      <button
        type="button"
        aria-label={label}
        title={`${label} (${modifierKey} K)`}
        onClick={() => setOpen(true)}
        className={cn(
          'flex w-full items-center justify-between rounded-8 px-3 py-2 text-left transition-colors',
          'bg-transparent hover:bg-system-white04 focus-visible:bg-system-white04 focus-visible:outline-none',
          'light:hover:bg-white/70 light:focus-visible:bg-white/70',
        )}
      >
        <span className="flex min-w-0 items-center gap-2">
          <BaseLineSearch className="size-4 shrink-0 light:text-system-text05 text-system-white40" />
          <span className="truncate font-[Poppins] light:text-system-text05 text-system-white40 text-xs">{label}</span>
        </span>
        <span className="shrink-0 font-[Poppins] light:text-system-text06 text-system-white48 text-xs">
          {modifierKey} K
        </span>
      </button>

      <SearchDialog open={open} onOpenChange={setOpen} />
    </>
  );
};
